(function($) {
	$(document).ready(function(){
		// Order by select menu
		if ($.fn.selectmenu) {
			var $orderby = $('.archive.woocommerce-page .orderby');
			if ($orderby.length) {
				$orderby.selectmenu({
					select: function(event, ui) {
						$orderby.parent().submit();
					}
				});
			}
		}

		// Product filter
		var $productFilter = $( '.archive.woocommerce-page .widget_product_categories' );
		if ($productFilter.length) {
			var productFilterIsSet = false;

			function productFilterInit() {
				$productFilter.accordion({
					collapsible: true,
					icons: false,
					active: false
				});
				productFilterIsSet = true;
			}

			function productFilterDestroy() {
				if ($productFilter.is('.ui-accordion')) {
					$productFilter.accordion('destroy');
					productFilterIsSet = false;
				}
			}

			if ($(window).width() < 992) {
				productFilterInit();
			}

			$(window).resize(function() {
				if ($(window).width() < 992 && !productFilterIsSet) {
					productFilterInit();
				} else if ($(window).width() >= 992 && productFilterIsSet) {
					productFilterDestroy();
				}
			});
		}

		// Product gallery
		if ($.fn.slick) {
			var $productGalleryWrapper = $('figure.woocommerce-product-gallery__wrapper');
			if ($productGalleryWrapper.length) {
				$productGalleryWrapper.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					prevArrow: '<button class="slick-prev"><img src="/wp-content/uploads/chevron-left.png" alt=""></button>',
					nextArrow: '<button class="slick-next"><img src="/wp-content/uploads/chevron-right.png" alt=""></button>',
				});
			}
		}

		$('.single-product .woocommerce-product-gallery__image a').on('click', function(event) {
			event.preventDefault();
			var win = window.open($(this).attr('href'), '_blank');
			if (win) {
			    //Browser has allowed it to be opened
			    win.focus();
			} else {
			    //Browser has blocked it
			    alert('Please allow popups for this website');
			}
		});
	});
})(jQuery);
